export default __webpack_public_path__ + "static/media/storyImageItem.9b675716.svg";